var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSEtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 40,
    viewBox: "0 0 71 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 9.16344 11.1634 2 20 2H51C59.8366 2 67 9.16344 67 18C67 26.8366 59.8366 34 51 34H20C11.1634 34 4 26.8366 4 18Z",
    fill: "#282D4B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.257 22.962V11.301H43.191V22.962H44.257ZM40.838 12.562H35.378V13.42H39.759C39.538 16.189 37.978 18.425 34.845 19.92L35.417 20.791C39.304 18.88 40.838 15.929 40.838 12.562ZM54.618 16.878H56.542V15.981H54.618V11.301H53.552V22.949H54.618V16.878ZM47.221 19.283V16.488H51.329V15.63H47.221V13.225H51.589V12.354H46.155V20.154H47.065C49.262 20.154 50.77 20.076 52.564 19.764L52.46 18.906C50.718 19.179 49.301 19.283 47.221 19.283Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 23.3333C24.9455 23.3333 27.3333 20.9455 27.3333 18C27.3333 15.0545 24.9455 12.6667 22 12.6667C19.0544 12.6667 16.6666 15.0545 16.6666 18C16.6666 20.9455 19.0544 23.3333 22 23.3333ZM22 24.3333C25.4978 24.3333 28.3333 21.4978 28.3333 18C28.3333 14.5022 25.4978 11.6667 22 11.6667C18.5022 11.6667 15.6666 14.5022 15.6666 18C15.6666 21.4978 18.5022 24.3333 22 24.3333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18C23 18.5523 22.5522 19 22 19C21.4477 19 21 18.5523 21 18C21 17.4477 21.4477 17 22 17C22.5522 17 23 17.4477 23 18Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18C26 18.5523 25.5522 19 25 19C24.4477 19 24 18.5523 24 18C24 17.4477 24.4477 17 25 17C25.5522 17 26 17.4477 26 18Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18C20 18.5523 19.5522 19 19 19C18.4477 19 18 18.5523 18 18C18 17.4477 18.4477 17 19 17C19.5522 17 20 17.4477 20 18Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_2936",
    x: 0,
    y: 0,
    width: 71,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_2936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_2936",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSEtc);
export default __webpack_public_path__ + "static/media/s_etc.c29ee56f7dad576135957dde178673a2.svg";
export { ForwardRef as ReactComponent };